export const getUTMAttributes = () => {
  // Retrieve UTMAttributes from Shopify cookie
  const analytics: string | undefined = document.cookie
    .split(";")
    .map((x) => x.trim().match(/^_shopify_sa_p=(.*)/))
    .filter((x): x is RegExpMatchArray => x !== null)
    .map(([_, value]) => value)[0];

  const params = new URLSearchParams(decodeURIComponent(analytics ?? ""));

  return {
    utm_source: params.get("utm_source"),
    utm_campaign: params.get("utm_campaign"),
  };
};
